import { SOURCE_FIELD_KEYS } from './constants';

export const resetSourceInfoFields = (providerFields, setValue) => {
    if (!providerFields || !setValue) return;
    Object.values(SOURCE_FIELD_KEYS).forEach((key) =>
        setValue(key, providerFields?.includes(key)),
    );
};
